import { useMemo } from 'react';

import { AppID } from '@playq/octopus-common';
import { CheckFileRequest, CheckFileResponse, FileState } from '@playq/octopus2-files';
import { GenericFailure } from '@playq/services-shared';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';

import { checkFileKeys } from './constants';

export type UseFileCheckArgs = { appID?: AppID; check?: CheckFileRequest };

export const useCheckFile = (
  { check }: UseFileCheckArgs,
  options?: IUseQueryOptionsExtended<CheckFileResponse | undefined, GenericFailure | Error>
) => {
  const keys = useMemo(() => checkFileKeys.concat(check), [check]);

  const res = useEitherQuery(keys, () => services2.filesService.checkFile(check as CheckFileRequest), {
    ...options,
    enabled: options?.enabled !== false && check !== undefined,
  });

  return {
    ...res,
    status: res.data?.state ?? FileState.NotFound,
    tags: keys,
  };
};

export type UseCheckFileType = typeof useCheckFile;
